import React from 'react'
import styles from './index.module.scss'

const MobileBtnLink = ({ to, className, children }) => (
  <a href={to} className={`${className} ${styles.catLink} block border-black border w-full text-center py-8`}>{children}</a>
)

export default MobileBtnLink
